import React from 'react'
import Header from './Header'
import RateList from './RateList'

const Rates = () => {
  return (
    <div>
      <Header />
      <RateList/>
    </div>
  )
}

export default Rates